import React from "react"
import ContactAvatar from "../../../cards/ContactAvatar"
import { SvgCheckbox, SvgCheckboxOff } from "../../../icons/"

type Props = {
  parentHandleSelect: any
  contact: any
  isSelected: boolean
}

const MobileInviteContactsListItem: React.FC<Props> = ({
  parentHandleSelect,
  contact,
  isSelected,
}) => {
  const [selected, setSelected] = React.useState<boolean>(isSelected || false)

  const handleSelectContactClick = () => {
    setSelected(() => !selected)
    parentHandleSelect(contact.profile_id)
  }

  return (
    <div className="flex items-center justify-between py-[8px] min-w-[320px]">
      <div
        className="flex items-center w-[80%] 
        "
        onClick={handleSelectContactClick}
      >
        <ContactAvatar
          contact={contact}
          width={48}
          height={48}
          bold={false}
          fontSize={"text-[18px]"}
        />
        <h3 className="font-bold ml-[8px] truncate text-base w-[80%]">
          {contact.contact_name}
        </h3>
      </div>

      <div className="ml-[18px] cursor-pointer">
        {selected ? <SvgCheckbox /> : <SvgCheckboxOff className="border border-[gray] rounded-md"/>}
      </div>
    </div>
  )
}

export default MobileInviteContactsListItem
